import React from 'react';
import AppSettingsContext from '../context.js';
import {Arrow} from '../templates/elements.js';

/*---------------------------------------------*/

export default class Pagination extends React.Component {
	static contextType = AppSettingsContext;

	render() {
		let arrowsSettings = {
			type: this.context.get('layout.slider.arrows.type','sharp'),
			container: this.context.get('layout.grid.arrows.container','square'), /* rectangular / square / square-spaced / circle-spaced */
			size: this.context.get('layout.slider.arrows.size',16),
			color: this.context.get('layout.slider.arrows.color','black'),
			background: this.context.get('layout.slider.arrows.background')
		}

		let arrowHeight = arrowsSettings.size*2;
		let arrowWidth = arrowsSettings.container === 'rectangular' ? arrowsSettings.size*3-4 : arrowsSettings.size*2;

		let styles = {
			container: {
				...this.props.baseStyle,
				fontSize: 0,
				paddingTop: 12,
				paddingBottom: 12
			},
			arrows: {
				common: {
					display: 'inline-block',
					position: 'relative',
					cursor: 'pointer',
					transition: 'opacity .1s'
				}
			}
		}

		styles.arrows.left = {
			...styles.arrows.common
		};

		let arrowSpacing = arrowsSettings.container.endsWith('-spaced');
		styles.arrows.right = {
			...styles.arrows.common,
			marginLeft: arrowSpacing ? arrowsSettings.size / 2 : -1
		};
		
		let props = {
			left: {
				dir: "left",
				width: arrowWidth,
				height: arrowHeight,
				baseStyle: styles.arrows.left,
				state: this.props.prev ? "enabled" : "disabled",
				spaced: arrowSpacing
			},
			right: {
				dir: "right",
				width: arrowWidth,
				height: arrowHeight,
				baseStyle: styles.arrows.right,
				state: this.props.next ? "enabled" : "disabled",
				spaced: arrowSpacing
			}
		}

		return (
			<div className="pagination" style={styles.container} ref={this.container}>
				<Arrow {...arrowsSettings} {...props.left} onClick={this.props.prev}></Arrow>
				<Arrow {...arrowsSettings} {...props.right} onClick={this.props.next}></Arrow>
			</div>
		)
	}
}

/*---------------------------------------------*/
